import {Component, Input} from '@angular/core';
import {BatchUploadMetadata} from '../../../entity/batch-upload';
import {LocalizationPipePipe} from '../../../../localization/control/localisation-pipe-pipe';

@Component({
  selector: 'app-single-single-batch-upload-metadata',
  imports: [
    LocalizationPipePipe
  ],
  templateUrl: './single-batch-upload-metadata.component.html',
  styleUrl: './single-batch-upload-metadata.component.scss'
})
export class SingleBatchUploadMetadata {
  @Input() batchUploadMetadata?: BatchUploadMetadata;

}
